import { TableColumn } from "../pages/ListReceipt";

const urlContainsCsAdmin = window.location.href.includes("cs-admin");

export const columns: TableColumn[] = [
  { key: "image", header: "Image" },
  { key: "receipt_number", header: "Receipt Number" },
  { key: "receipt_date", header: "Receipt Date" },
  { key: "amount", header: "Amount" },
  {
    key: "calculated_receipt_amount",
    header: "Adjusted Amount $",
  },
  { key: "yuuAmount", header: "yuu amount" },
  { key: "submission_date", header: "Submitted Date" },
  { key: "review_date", header: "Reviewed Date" },
  { key: "merchant", header: "Merchant" },
  { key: "subcategory", header: "Subcategory" },
  { key: "points_awarded", header: "Points Awarded" },
  { key: "bonus_point", header: "Bonus Points" },
  { key: "status", header: "Status" },
 
];

export const metaData = {
  image: {
    isImage: true,
    linkTo: "",
  },
  amount: {
    isImage: false,
    linkTo: "",
  },
  calculated_receipt_amount: {
    isImage: false,
    linkTo: "",
  },
  merchant: {
    isImage: false,
    linkTo: "",
  },
  merchant_type: {
    isImage: false,
    linkTo: "",
  },
  receipt_number: {
    isImage: false,
    linkTo: "",
  },
  submission_date: {
    isImage: false,
    linkTo: "",
  },
  status: {
    isImage: false,
    linkTo: "",
  },
  review_date: {
    isImage: false,
    linkTo: "",
  },
  points_awarded: {
    isImage: false,
    linkTo: "",
  },
  birthday_points: {
    isImage: false,
    linkTo: "",
  },
  partner: {
    isImage: false,
    linkTo: "",
  },

  redeem: {
    isImage: false,
    linkTo: "",
  },
};
